var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"fj-env",rawName:"v-fj-env"}],staticClass:"tab-move-button-wrapper",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"tab-move-button",class:_vm.classNames})])}
var staticRenderFns = []

export { render, staticRenderFns }